const messages = {
  'shell.players': 'Spieler',
  'shell.actions': 'Aktionen',
  'shell.history': 'Verlauf',
  'shell.chat': 'Chat',
  'shell.close': 'Schließen',
  'shell.fullscreen': 'Vollbild',
  'shell.sidebar': 'Spielinformationen',
  'shell.navOpen': 'Leiste ausklappen',
  'shell.navClose': 'Leiste einklappen',
  'shell.hapticsOn': 'Vibration an',
  'shell.hapticsOff': 'Vibration aus',
  'shell.soundOn': 'Ton an',
  'shell.soundOff': 'Ton aus',
  'graphics.unsupportedTitle': 'Grafik nicht verfügbar',
  'graphics.unsupportedBody':
    'Dieses Spiel benötigt WebGL. Aktualisiere deinen Browser oder aktiviere die Hardwarebeschleunigung.',
  'graphics.loading': 'Spielfläche wird vorbereitet …',
  'common.retry': 'Erneut versuchen',
};

export function t(key, params = {}, fallback = key) {
  let value = messages[key] || fallback;
  for (const [name, replacement] of Object.entries(params)) {
    value = value.replaceAll(`{${name}}`, String(replacement));
  }
  return value;
}

export function registerMessages(entries) {
  Object.assign(messages, entries || {});
}
